import React from 'react';
import { MenuItem, Select } from '@mui/material';
import Props from '../../types/props';
import Text from './Text';
function DropdownSelect({ ...props }: Props) {
  const { extra, style } = props;
  const { placeholder, options } = extra;

  return (
    <Select
      value={props.value}
      name={props.name}
      id={props.id}
      sx={style}
      readOnly={props.readOnly}
      disabled={props.disabled}
      defaultValue={options[0].name}
      displayEmpty
      onBlur={props.onBlur}
      onChange={(e: any) => {
        if (props.onChange) {
          props.onChange(e);
        }
      }}
      renderValue={options => {
        if (options.length === 0) {
          return (
            <Text style={{ fontSize: 13, color: '#bbbbbb' }}>
              {placeholder}
            </Text>
          );
        }
        return <Text style={{ fontSize: 13 }}>{options}</Text>;
      }}>
      {options.map((value: Record<string, unknown>, index: number) => {
        return (
          <MenuItem value={index} key={index}>
            <Text style={{ fontSize: 13, fontWeight: 'normal' }}>
              {(value['name'] ?? '').toString()}
            </Text>
          </MenuItem>
        );
      })}
    </Select>
  );
}

export default DropdownSelect;
